import { render } from "./savingMoneyCardDesc.vue?vue&type=template&id=084e4b5b&scoped=true"
import script from "./savingMoneyCardDesc.vue?vue&type=script&lang=js"
export * from "./savingMoneyCardDesc.vue?vue&type=script&lang=js"

import "./savingMoneyCardDesc.vue?vue&type=style&index=0&id=084e4b5b&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084e4b5b"]])

export default __exports__